import { useLocation } from "react-router-dom";
import { useSEO } from "@/hooks/useSEO";
import { seoData } from "@/data/seoData";

export default function NotFound() {
  const location = useLocation();
  useSEO(seoData.notFound);

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <span className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
        404
      </span>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6">Cette page n'existe pas</h1>
        <p className="mt-2 text-base text-gray-400 font-mono">{location.pathname}</p>
        <a href="/" className="mt-4 inline-block text-lg md:text-xl text-[#FF6B4A] underline underline-offset-4">
          Retour à l'accueil
        </a>
      </div>
    </div>
  );
}